import { render } from "./CIS-Blockquote-Carousel-Item.vue?vue&type=template&id=61869032&scoped=true"
import script from "./CIS-Blockquote-Carousel-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Blockquote-Carousel-Item.vue?vue&type=script&lang=js"

import "./CIS-Blockquote-Carousel-Item.vue?vue&type=style&index=0&id=61869032&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61869032"]])

export default __exports__